<div class="flex flex-col">
    <p-scroll-panel [style]="{ width: '100%', height: '600px' }" class="pb-0!">
        @for (historique of historiques; track historique.id) {
            <div class="flex items-center justify-between border-b border-solid border-surface-200 dark:border-surface-700 py-2 text-lg">
                <div>
                    <span [class]="utilityService.getHistoryActionClass(historique.direction)">{{historique.mouvement}}</span> quantité(s) <span [class]="utilityService.getHistoryActionClass(historique.direction)">{{ utilityService.getHistoryActionLabel(historique.direction) }}</span> le {{ historique.created_at | date:'shortDate' }} par {{ historique.user?.full_name }}
                </div>
                <div class="pr-2">
                    Quantité à la date : <span [class]="utilityService.getHistoryActionClass(historique.direction)">{{historique.quantite_a_date}}</span>
                </div>
            </div>
        }
        @if (historiques && historiques.length === 0) {
            <div class="p-4 text-center text-surface-500 dark:text-surface-400">
                Aucun historique de mouvement de stock pour ce stock.
            </div>
        }
    </p-scroll-panel>
</div>

